import type { ActionKey } from '../api/types';
import { useI18n } from '../i18n';
import type { StringKey } from '../i18n/strings';

/** 動作 → 圖示。emoji 一律 aria-hidden，真正的名稱用文字提供給螢幕閱讀器。 */
export const ACTION_GLYPH: Record<string, string> = {
  rock: '✊', // ✊
  paper: '✋', // ✋
  scissors: '✌️', // ✌️
};

export function actionLabelKey(action: ActionKey): StringKey {
  switch (action) {
    case 'rock':
      return 'action.rock';
    case 'paper':
      return 'action.paper';
    case 'scissors':
      return 'action.scissors';
    default:
      return 'action.rock';
  }
}

interface Props {
  legalActions: ActionKey[];
  disabled: boolean;
  /** 我已經選了什麼。**永遠只可能是我自己的選擇。** */
  selected: ActionKey | null;
  onPick(action: ActionKey): void;
}

export function ChoiceButtons({ legalActions, disabled, selected, onPick }: Props) {
  const { t } = useI18n();
  return (
    <div className="choices" role="group" aria-label={t('match.chooseNow')}>
      {legalActions.map((action) => {
        const label = t(actionLabelKey(action));
        return (
          <button
            key={action}
            type="button"
            className="choice"
            disabled={disabled}
            aria-pressed={selected === action}
            onClick={() => onPick(action)}
          >
            <span className="choice__glyph" aria-hidden="true">
              {ACTION_GLYPH[action] ?? '?'}
            </span>
            <span>{label}</span>
          </button>
        );
      })}
    </div>
  );
}
